'use strict';

import LoggerBuilder from './logger-builder';

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
export function create(appName, {baseUrl = null, appId = null, isWidgetLogger = false, errorHandlerToggle = false, disableAutoLoadFinish = false, swallowExceptions = false, interactionTimeout = null, timeoutHook = null, startHook = null, endHook = null} = {}) {
  const appVersion = typeof window !== 'undefined' ? window.__CI_APP_VERSION__ : null;

  return new LoggerBuilder()
    .setAppName(appName)
    .setAppVersion(appVersion)
    .setBaseUrl(baseUrl)
    .setAppId(appId)
    .setErrorHandlerToggle(errorHandlerToggle)
    .setSwallowExceptions(swallowExceptions)
    .setWidgetLogger(isWidgetLogger)
    .setInteractionTimeout(interactionTimeout)
    .setTimeoutHook(timeoutHook)
    .setStartHook(startHook)
    .setEndHook(endHook)
    .setDisableAutoLoadFinish(disableAutoLoadFinish)
    .build();
}



// WEBPACK FOOTER //
// ./logger-factory.js